import MainLayout from "@/components/layouts/MainLayout"
import CartoonDetailPage from "@/components/pages/CartoonDetailPage"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import { ReactElement } from "react"

const Page = () => <CartoonDetailPage />

Page.getLayout = function getLayout(page: ReactElement) {
  return <MainLayout>{page}</MainLayout>
}

export async function getServerSideProps({ locale, params }) {
  const translations = await serverSideTranslations(locale, ["common", "dashboard"])

  const fetchedCartoonData = {
    params: params,
  }

  return {
    props: {
      cartoonData: fetchedCartoonData,
      ...translations,
    },
  }
}

export default Page
